export const DEFAULT_PAGE_SIZE = 5;

export const PAGE_SIZES = [5, 10, 15, 50, 100];

export const PAGE_OPTIONS = PAGE_SIZES.map((size) => {
  return { id: size, name: String(size), value: size };
});
